module.exports = __webpack_public_path__ + "img/iconAvailable.d17dc7cb.png";